import { View } from '../types';

export const enrichItems = (items: any[], views?: View[]): any[] => {
  if (!views || views.length === 0) return items;

  const camposMap = new Map<number, any>(
    views[0].campos
      .map((campo) => {
        const codCampoNum = Number(campo.cod_campo);
        return !Number.isNaN(codCampoNum) ? [codCampoNum, campo] : null;
      })
      .filter((entry): entry is [number, any] => entry !== null),
  );

  return items.map((item) => {
    const codCampoNum = Number(item.cod_campo);
    if (Number.isNaN(codCampoNum)) return item;

    const campoInfo = camposMap.get(codCampoNum);
    if (!campoInfo) return item;

    return {
      ...item,
      cod_tipo_dados: campoInfo.cod_tipo_dados,
      des_tipo_dados: campoInfo.des_tipo_dados,
    };
  });
};
